<template>
  <div id="func-16">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
    />
    <SolicitacaoHistorico
      :chave-externa="'extrato'"
      :funcionalidade="funcionalidade"
      :lista-externa="listaComData"
      :rota-detalhe="rotaDetalhe"
    >
      <template v-slot:default="{card}">
        <div
          @click="onClickRow(card)"
        >
          <ListaExtratoAutorizacaoCard
            :card="card"
            :showWidgetActions="showWidgetActions"
            :preloadWidget="() => carregaPayloadWidget(card)"
          />
        </div>
      </template>
    </SolicitacaoHistorico>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoHistorico from '@/components/TemplateSolicitacao/SolicitacaoHistorico'
import ListaExtratoAutorizacaoCard from './components/ListaExtratoAutorizacaoCard'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import { preloadWidget } from '@/views/31/PreLoadWidget31'

export default {
  name: 'Func16Historico',
  components: {
    ListaExtratoAutorizacaoCard,
    SolicitacaoHistorico,
    FuncionalidadeHeader
  },
  data () {
    return {
      contratosList: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade', 'embedJson']),
    ...mapGetters('Login', ['user']),
    ...mapGetters('SetupApp', ['canalAtendimentoOrigem', 'isWidget']),
    showWidgetActions () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    listaComData () {
      let data = []
      let lista = this.contratosList
      if (lista.length > 0) {
        lista.map((obj) => {
          const tempLista = obj.extrato.map((el) => {
            let data = el.guia.dataSolicitacao
            let timestamp = new Date(data).getTime()
            return {
              ...el,
              data_registro: timestamp,
              cardExterno: true
            }
          })
          data.push({
            numeroContrato: obj.numeroContrato,
            extrato: tempLista
          })
        })
      }
      return data
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    },
    periodoBuscaMeses () {
      return this.funcionalidade.parametros.periodoBuscaMeses
    }
  },
  methods: {
    async init () {
      await this.listaExtratos()
    },
    async listaExtratos () {
      const data = new Date()
      data.setMonth(data.getMonth() - this.periodoBuscaMeses)
      const dataInicial = data.toISOString().split('T')[0]
      const dataFinal = new Date().toISOString().split('T')[0]

      let result = await this.apiFuncionalidade.listaExtratos({
        payload: {
          dataInicial: dataInicial,
          dataFinal: dataFinal
        },
        handlerErrorIgnore: true
      })
      this.contratosList = result.data.contratos
    },
    async onClickRow (row) {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return this.$router.push({
            path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
            query: {
              idAutorizacao: row['guia']['idAutorizacao']
            }
          })
      }
    },
    carregaPayloadWidget (row) {
      return preloadWidget(
        row,
        this.funcionalidade,
        this.embedJson.atendimento.tokenAtendente,
        this.aplicacao
      )
    }
  },
  mounted () {
    this.init()
  }
}
</script>
